//filter search
import $ from "jquery";

$(function () {
    $('.filter').on('submit', function (e) {
        e.preventDefault();
        $('#result, .searched,#result_modal').removeClass('hidden');
        getContent()
    })

    $(document).on('click', '.reset_filter', function (e) {
        e.preventDefault();
        if($(".type-b").length <0){
            $('.form-submit span').text("検索");
        }

        $('#result, .searched,#result_modal').addClass('hidden');
        $('#result_content').html('')
        if($(".sidebar-warp").length >0){
            $(".sidebar-warp").removeClass("blue");
            if($(window).innerWidth() > 767){
                $('.type-b .form-submit.btn-blue').addClass("hidden");
                $('.type-b .form-submit.btn-blue2').removeClass("hidden");
            }
        }

        if ($(window).innerWidth() >= 768 && $('.s3-filter').length && !$(".type-b").length) {
            $('html, body').animate({
                scrollTop: $('.maintab').offset().top
            }, 300)
        }
        if($(".type-b").length >= 0){
            $('.form-result-number').text("00");
        }
    })

    $('.reset_filter2').on('click', function (e) {
        e.preventDefault();
        $('.form-submit span').text("検索");
        $('.maintab > li:nth-child(1) > a').trigger('click')
        if($(".type-b").length > 0 && $(window).innerWidth() > 767){
        }else{
            $('html, body').animate({
                scrollTop: $('.maintab').offset().top
            }, 300)
        }
    })

    function apiCall() {
        let filterData = new FormData($('.filter:visible')[0]);
        return $.ajax({
            // url: "/filter.php",
            url: "/comparing_wimax/filter.php",
            data: filterData,
            cache: false,
            processData: false,
            contentType: false,
            type: 'POST',
        });
    }

    async function getContent() {
        $('.result-loading').toggleClass('hidden')
        let res = await apiCall();

        if($(".sidebar-warp").length >0){
            $(".sidebar-warp").addClass("blue");
        }

        if (res.length) {
            if($(".type-b").length >0 && $(window).innerWidth() <= 767){
                $('#result_content_sp').html(res)
            }else{

                $('#result_content').html(res)
            }

            let total = $('.total_search').text();
            $('.form-result-number').text(total)

        } else {
            if($(".type-b").length >0 && $(window).innerWidth() <= 767){
                $('#result_content_sp').html('<div class="none-content">お探しのプロバイダが見つかりません。</div>')
                $('.form-result-number').text("00")
            }else{

                $('#result_content').html('<div class="none-content">お探しのプロバイダが見つかりません。</div>')
                $('.form-result-number').text("00")
            }

        }

        if ($(window).innerWidth() <= 767) {
            setTimeout(() => {

                $('.form-submit span').text("もう一度検索");

                $('html, body').animate({
                    scrollTop: $('#result').offset().top
                }, 300)
            }, 0);
        }

        $('.result-loading').toggleClass('hidden')
    }


})
